var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3568 17.7309L24.1315 20.6882L19.4448 16.0309L24.1688 11.3362L29.3568 14.2722C29.663 14.4453 29.9177 14.6967 30.095 15.0005C30.2722 15.3043 30.3656 15.6498 30.3656 16.0015C30.3656 16.3533 30.2722 16.6987 30.095 17.0026C29.9177 17.3064 29.663 17.5577 29.3568 17.7309ZM1.78215 1.23219C1.68366 1.47254 1.63294 1.72978 1.63281 1.98952V30.0122C1.63281 30.3015 1.69281 30.5709 1.79815 30.8122L16.6715 16.0295L1.78215 1.23219ZM18.0581 14.6522L22.4021 10.3349L4.59948 0.26019C4.21775 0.0412996 3.77346 -0.0427671 3.33815 0.021523L18.0581 14.6522ZM18.0581 17.4082L3.39148 31.9855C3.78881 32.0335 4.20748 31.9642 4.59948 31.7415L22.3648 21.6882L18.0581 17.4082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.24636d717ff4b837ccd1cc1060e53753.svg";
export { ForwardRef as ReactComponent };